function Button({ children, type, disabled, onClick, className }) {
    return (
        <button
            className={`${
                className || ''
            } inline-flex min-h-[2.5rem] items-center justify-center rounded-md border border-transparent bg-blue-700 px-4 py-2 text-sm font-medium text-gray-100 shadow hover:bg-blue-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400`}
            type={type || 'button'}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default Button;
